/**
 * Router-shell do modulo Suprimentos (Fase 7 + Plano de Suprimentos 2026-09).
 *
 * Sub-rotas:
 *   /suprimentos                       -> redireciona p/ produtos
 *   /suprimentos/produtos              -> Cadastro de Suprimentos (saldo fisico/reservado/disponivel)
 *   /suprimentos/movimentos            -> Historico de movimentos (+ ajuste com motivo)
 *   /suprimentos/depositos             -> Depositos + transferencia
 *   /suprimentos/sobras                -> Aproveitamento de Sobras + Boxes
 *   /suprimentos/inventario            -> Sessoes de inventario
 *   /suprimentos/ajustes-pendentes     -> Ajustes aguardando aprovacao
 *   /suprimentos/solicitacoes-cadastro -> Fila de cadastro (Cut/CAD/manual)
 *   /suprimentos/configuracao          -> Configuracao da unidade + motivos
 *   /suprimentos/fornecedores          -> CRUD fornecedores
 *   /suprimentos/ordens-compra         -> Lista + drill de OCs (com entrada)
 *
 * /suprimentos/requisicoes vive FORA deste shell (RequisicoesCompra, rota
 * mais especifica no App.jsx).
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { PageContainer } from "../../styles/shared";

import ConfiguracaoSuprimentos from "./ConfiguracaoSuprimentos";
import Depositos from "./Depositos";
import Fornecedores from "./Fornecedores";
import Inventario from "./Inventario";
import Movimentos from "./Movimentos";
import OrdensCompra from "./OrdensCompra";
import Produtos from "./Produtos";
import Sobras from "./Sobras";
import MateriaisACadastrar from "./MateriaisACadastrar";

// Sem menu interno (pedido do dono, 2026-09-10): as paginas do modulo ja
// estao na sidebar principal; repetir aqui era redundante.
function Suprimentos() {
  return (
    <PageContainer>
      <Routes>
        <Route index element={<Navigate to="produtos" replace />} />
        <Route path="produtos" element={<Produtos />} />
        <Route path="movimentos" element={<Movimentos />} />
        <Route path="depositos" element={<Depositos />} />
        <Route path="sobras" element={<Sobras />} />
        <Route path="inventario" element={<Inventario />} />
        {/* Bloco 4: a fila de ajustes virou aba de Movimentos. */}
        <Route path="ajustes-pendentes" element={<Navigate to="/suprimentos/movimentos?aba=aprovacao" replace />} />
        <Route path="materiais-a-cadastrar" element={<MateriaisACadastrar />} />
        {/* Rota antiga: as duas filas viraram uma (ADR-0068). */}
        <Route path="solicitacoes-cadastro" element={<Navigate to="/suprimentos/materiais-a-cadastrar" replace />} />
        <Route path="fornecedores" element={<Fornecedores />} />
        <Route path="ordens-compra" element={<OrdensCompra />} />
        <Route path="configuracao" element={<ConfiguracaoSuprimentos />} />
      </Routes>
    </PageContainer>
  );
}

export default Suprimentos;
